import React, { FC } from 'react';
import { Typography, Box } from '@mui/material';
import { TruncatedText } from 'components/generic';

interface InfoProps {
  productName: string;
  description: string;
}

const Info: FC<InfoProps> = ({ productName, description }) => {
  return (
    <>
      <Box
        sx={{
          minHeight: { xs: '0px', md: '90px' },
          flexGrow: '1',
          marginBottom: '10px',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '16px', sm: '20px' },
            lineHeight: { xs: '19px', sm: '23px' },
            fontWeight: '400',
            color: 'text.primary',
            marginBottom: '6px',
            textAlign: { xs: 'center', sm: 'left' },
            wordBreak: 'break-word',
            hyphens: 'auto',
          }}
          variant="h5"
        >
          {productName}
        </Typography>
        <TruncatedText
          sx={{
            fontSize: '14px',
            lineHeight: '18px',
            fontWeight: '300',
            display: { xs: 'none', sm: 'block' },
            color: 'text.primary',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            hyphens: 'auto',
          }}
          text={description}
          maxLines={6}
        />
      </Box>
    </>
  );
};

export default Info;
